import type { ReactNode } from 'react';

import type { SettingsProps } from '../types';

/**
 * Settings container component.
 *
 * This is a declarative/config component that returns null.
 * Settings are parsed from children by parseChildren.
 *
 * @example
 * ```tsx
 * <DataTable.Settings>
 *   <DataTable.Density value="comfortable" />
 *   <DataTable.StickyHeader height="4rem" />
 *   <DataTable.Cache properties={['sizing', 'sorting']} />
 * </DataTable.Settings>
 * ```
 */
export const Settings = (_props: SettingsProps): ReactNode => {
  // Pure declarative component - children are parsed by parseChildren
  return null;
};

Settings.displayName = 'DataTable.Settings';
